import { render, staticRenderFns } from "./AtomSpecsInfo.vue?vue&type=template&id=7c648096&scoped=true&"
import script from "./AtomSpecsInfo.vue?vue&type=script&lang=js&"
export * from "./AtomSpecsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AtomSpecsInfo.vue?vue&type=style&index=0&id=7c648096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c648096",
  null
  
)

export default component.exports